import {
    ARABIC,
    COLLECTION_VALUES,
    ENGLISH,
    LEFT,
    RIGHT,
    TEXT_LEFT,
    TEXT_RIGHT,
} from "../../public/Constants/EnumConstants";
import {
    STYLE_MY_WARDROBE,
    STYLE_WORDROPE_ROUTES,
} from "../../public/Constants/EnumConstants";
import { deleteCookie, getCookie } from "cookies-next";

import { BACKEND_ENDPOINTS } from "../../public/Constants/endpoints";
import { FRONTEND_ENDPOINTS } from "../../public/Constants/endpoints";
import { createClient } from "../../prismicio";
import { toast } from "react-toastify";
import { sorting } from "@/lib/bigcommerce/restfull/helpers/constants";

const getAlignment = (locale) => {
    return locale === ARABIC ? RIGHT : LEFT;
};
const getAlignmentClass = (locale) => {
    return locale === ENGLISH ? TEXT_LEFT : TEXT_RIGHT;
};
const splitSliceIntoTwoParts = (array) => {
    const first_slice = array?.items?.slice(0, 2);
    const second_slice = array?.items?.slice(2);
    return { first_slice, second_slice };
};
const formatDate = (inputDate) => {
    let date, month, year;

    date = inputDate?.getDate();
    month = inputDate?.getMonth() + 1;
    year = inputDate?.getFullYear();

    date = date?.toString().padStart(2, "0");

    month = month?.toString().padStart(2, "0");

    return `${date}/${month}/${year}`;
};

const formatDateYMD = (inputDate) => {
    if (inputDate === null) return;
    let date, month, year;
    date = inputDate?.getDate();
    month = inputDate?.getMonth() + 1;
    year = inputDate?.getFullYear()?.toString();

    date = date?.toString().padStart(2, "0");

    month = month?.toString().padStart(2, "0");

    return `${year}-${month}-${date}`;
};

const mmToFeetInches = (mm) =>
    `${Math.floor(mm / 25.4 / 12)} ft ${Math.ceil((mm / 25.4) % 12)} in`;

const gramsToKgs = (grams) => `${Math.ceil(grams / 1000)} kg`;

export {
    getAlignment,
    getAlignmentClass,
    splitSliceIntoTwoParts,
    formatDate,
    formatDateYMD,
    mmToFeetInches,
    gramsToKgs,
};

export const fetchLandingPageProducts = async () => {
    let BASE_URL = `${process.env.BACKEND_URL}${BACKEND_ENDPOINTS?.ECOM_PRODUCTS}`; // Corrected URL format
    let URL = BASE_URL;
    try {
        const response = await fetch(URL, {
            method: "GET",
            cache: "no-store",
        });
        if (response.ok) {
            const data = await response.json();
            // Process your data here
            return data;
        } else {
            console.error("Failed to fetch data:", response.status);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return error;
    }
};
export const fetchProduct = async (id) => {
    let BASE_URL = `${process.env.BACKEND_URL}${BACKEND_ENDPOINTS?.PRODUCT}${id}`; // Corrected URL format
    let URL = BASE_URL;
    try {
        const response = await fetch(URL, {
            method: "GET",
            cache: "no-store",
        });
        if (response.ok) {
            const data = await response.json();
            // Process your data here
            return data;
        } else {
            console.error("Failed to fetch data:", response.status);
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return error;
    }
};
export const generateSignature = (publicId, apiSecret) => {
    const timestamp = Math.floor(Date.now() / 1000);
    const signaturePayload = `public_id=${publicId}&timestamp=${timestamp}${apiSecret}`;
    const signature = crypto
        .createHash("sha1")
        .update(signaturePayload)
        .digest("hex");
    return { signature, timestamp };
};

export const fetchClientSideData = async (pageType) => {
    const client = createClient();
    try {
        const response = await client.getSingle(pageType);
        return response?.data;
    } catch (error) {
        if (typeof window !== "undefined") {
        }
        console.error("Error fetching client-side data:", error);
        return error;
    }
};

export const fetchPrismicDataById = async (pageType, id) => {
    const client = createClient();
    try {
        const page = await client?.getByUID(pageType, id);
        return page;
    } catch (error) {
        if (typeof window !== "undefined") {
        }
        console.error("Error fetching client-side data:", error);
        return error;
    }
};

export const fetchAllByType = async (type) => {
    const client = createClient();
    try {
        const pages = await client?.getAllByType(type);
        return pages;
    } catch (error) {
        if (typeof window !== "undefined") {
        }
        console.error("Error fetching client-side data:", error);
        return error;
    }
};

export const checkInvalidDatesForBox = (data) => {
    let { selectedDate, setDate, fieldName } = data;

    // list of invalid dates
    let invalidDates = ["2023-12-25", "2024-01-01"];
    const NOT_AVAILABLE_TEXT =
        "We are not available on the selected date for any services. Sorry for any inconvenience.";

    // check if the selected date is valid
    let dateInvalid = invalidDates?.find(
        (date) =>
            selectedDate?.getDate() === new Date(date)?.getDate() &&
            selectedDate?.getMonth() === new Date(date)?.getMonth()
    )
        ? true
        : false;

    // if the selected date is invalid then set the selected date to 1 day earlier
    if (dateInvalid) {
        let newDate = new Date(selectedDate);
        newDate?.setDate(newDate?.getDate() - 1);
        setDate(fieldName, newDate);
        toast(NOT_AVAILABLE_TEXT, { type: "error" });
        return;
    }
    return;
};

export const isIterable = (obj) => {
    // checks for null and undefined
    if (obj == null) {
        return false;
    }
    // returns the status of the object if it's iterable
    // returns true for string as it is iterable
    return typeof obj[Symbol.iterator] === "function";
};

export const resetSurvey = () => {
    localStorage.removeItem("surveyAnswers");
    localStorage.removeItem("surveyQuestions");
    localStorage.removeItem("survey_address_form");
    localStorage.removeItem("survey_autoComplete_address");
};

export const getURL = (userData, href) => {
    if (userData && Object.keys(userData).length !== 0) {
        const { submitted_survey, email_verified, payment_status, setting } =
            userData;

        if (!submitted_survey) {
            return FRONTEND_ENDPOINTS?.SURVEY;
        }
        if (email_verified === false) {
            return FRONTEND_ENDPOINTS?.SURVEY_COMPLETE;
        }
        switch (payment_status) {
            case "un_paid":
                return FRONTEND_ENDPOINTS?.CHECKOUT_ADDRESS;
            case "paid":
                return FRONTEND_ENDPOINTS?.DASHBOARD;
            default:
                return href;
        }
    }
    return href;
};

export const deleteWardrobeCookies = (pathName) => {
    const styleMyWardrobe = getCookie(STYLE_MY_WARDROBE);
    if (styleMyWardrobe) {
        const isWardropbeFasle = !STYLE_WORDROPE_ROUTES?.find((route) =>
            pathName?.includes(route)
        );
        if (isWardropbeFasle) deleteCookie(STYLE_MY_WARDROBE);
    }
};

//adding space between the country code and the number
export const formatPhoneNumber = (phone) => {
    return phone?.replace(/[\s\(\)-]/g, "");
};

export const calculateDiscountPercentage = (actualPrice, salePrice) => {
    // Extract numeric values from strings
    const actualPriceNumber = parseFloat(actualPrice?.replace(/[^0-9.]/g, ""));
    const salePriceNumber = parseFloat(salePrice?.replace(/[^0-9.]/g, ""));

    // Check if the extracted numbers are valid
    if (
        isNaN(actualPriceNumber) ||
        isNaN(salePriceNumber) ||
        actualPriceNumber <= 0 ||
        salePriceNumber < 0
    ) {
        throw new Error("Prices should be valid positive numbers.");
    }

    const discount =
        ((actualPriceNumber - salePriceNumber) / actualPriceNumber) * 100;
    return `${Math.round(discount)}% OFF`;
};

export function formatPrice(price, currency) {
    // Check if the price is a whole number

    const numericPrice = parseFloat(price);

    const formattedPrice = Number.isInteger(numericPrice)
        ? numericPrice
        : numericPrice.toFixed(2);

    // Concatenate the currency symbol with the price
    return `${currency} ${formattedPrice}`;
}

export const sortByVariantSize = (arr) =>
    arr.sort((a, b) => parseInt(a.variant_size) - parseInt(b.variant_size));

export const transformProducts = (dataArray) => {
    return dataArray?.map((data) => {
        // Only transform if 'parentId' exists
        if (data?.hasOwnProperty("parentId")) {
            return {
                inventory_level: data?.stock,
                variant_id: parseInt(data?.id), // Converting 'id' to a number
                product_id: parseInt(data?.parentId), // Converting 'parentId' to a number
                variant_size: data?.selectedOptions.find(
                    (option) => option?.name === "Size"
                )?.value,
                variant_color: data?.selectedOptions?.find(
                    (option) => option?.name === "Color"
                )?.value,
            };
        } else {
            // Return the object as is if 'parentId' doesn't exist
            return data;
        }
    });
};

export const convertToSlug = (text) => {
    return text
        ?.toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
        .replace(/^-+|-+$/g, ""); // Trim leading or trailing hyphens
};

export const showBackInStockBadge = (productCustomFields) => {
    const backInStockBadge = {
        backInStock: productCustomFields?.back_in_stock,
        expiry: productCustomFields?.expires_on,
    };
    const todaysDate = new Date();
    const expiryDate = new Date(backInStockBadge?.expiry);
    const expired = todaysDate?.getTime() > expiryDate?.getTime();
    return backInStockBadge?.backInStock ? !expired : false;
};

export const sortImages = (arr) => {
    if (typeof arr === "object")
        return arr.sort((a, b) => {
            // If `a` is the thumbnail, it goes first
            if (a.is_thumbnail) return -1;
            // If `b` is the thumbnail, it goes first
            if (b.is_thumbnail) return 1;
            // Otherwise, sort by `sort_order`
            return a.sort_order - b.sort_order;
        });
    else return null;
};

export const convertIntoSelectedCurrency = (amount, exchangeRate) => {
    const finalAmount =
        Math?.round(parseFloat(amount) * parseFloat(exchangeRate) * 100) / 100;

    return Math?.round(finalAmount);
};

export const createUrl = (pathname, params) => {
    const paramsString = params?.toString();
    const queryString = `${paramsString.length ? "?" : ""}${paramsString}`;

    return `${pathname}${queryString}`;
};

export const checkCartItemsStockAvailability = (products, setOutOfStock) => {
    let temp = false;
    products?.forEach(async (product) => {
        const { quantity, merchandise } = product;
        const selectedVariant = merchandise?.product?.variants?.find(
            (variant) => variant?.id === merchandise?.id
        );
        if (selectedVariant?.stock == 0 || selectedVariant?.stock < quantity) {
            temp = true;
        }
    });
    setOutOfStock(temp);
    return;
};

export const isTabbyValidCountry = (country) => {
    const validCountries = ["AE", "SA"];
    return !!validCountries.find((valCountry) => valCountry === country);
};

export function htmlToPlainText(html) {
    return html
        .replace(/<\/?[^>]+(>|$)/g, "") // Remove HTML tags
        .replace(/\s+/g, " ") // Normalize whitespace
        .trim(); // Remove leading/trailing spaces
}

export const createFiltersArray = ({ collection, color, size }) => {
    let productAttributesArr = [];
    if (collection) {
        productAttributesArr = [
            {
                attribute: "collection",
                values:
                    collection instanceof Array
                        ? collection?.map(
                              (name) => COLLECTION_VALUES?.[name] || name
                          )
                        : [COLLECTION_VALUES?.[collection]],
            },
        ];
    }
    if (size) {
        productAttributesArr = [
            ...productAttributesArr,
            {
                attribute: "Size",
                values:
                    size instanceof Array ? size?.map((name) => name) : [size],
            },
        ];
    }
    if (color) {
        productAttributesArr = [
            ...productAttributesArr,
            {
                attribute: "Color",
                values:
                    color instanceof Array
                        ? color?.map((name) => name)
                        : [color],
            },
        ];
    }

    return productAttributesArr;
};

export const buildGetProductsParams = (searchParams) => {
    const {
        sort,
        q: searchValue,
        collection,
        size,
        color,
        category,
        price,
        brand,
    } = searchParams;
    const parsedPrice = price && JSON.parse(price);
    const priceFilter = parsedPrice && {
        minPrice: parsedPrice[0],
        maxPrice: parsedPrice[1],
    };

    const { sortKey, reverse } =
        sorting?.find((item) => item?.slug === sort) ||
        (priceFilter && sorting[3]) ||
        sorting[5];

    const productAttributesArr = createFiltersArray({ color, size });
    const categoryEntityIds = Array?.isArray(category)
        ? category?.map((v) => Number(v) || "")
        : category
          ? [Number(category)]
          : [];
    const brandEntityIds = Array?.isArray(brand)
        ? brand?.map((v) => Number(v) || "")
        : brand
          ? [Number(brand)]
          : [];

    let params = {
        sortKey,
        reverse,
        query: searchValue,
        productAttributesArr,
        categoryEntityIds,
        priceFilter,
        brandEntityIds,
    };
    return params;
};
